import React, { useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Form,
	FormGroup,
	Label,
	Col,
} from 'reactstrap';
import Select from 'react-select';
import { Post } from '../../../../function/Koneksi';
import Dropzone from 'react-dropzone';
import Resizer from 'react-image-file-resizer';

const ModalPerangkat = ({ data, optionData, uuidLembaga, setAlert, isOpen, setIsOpen, statusRefresh, setStatusRefresh, propsData }) => {

	const frmPerangkat = {
		uuid: '',
		uuid_lembaga: uuidLembaga,
		uuid_jabatan_lembaga: null,
		uuid_bidang_lembaga: null,
		nama: '',
		status: '1',
		foto: '',
		foto_info: '',
	}

	const initFormData = {
		frmJabatan: optionData.frmJabatan,
		frmBidang: optionData.frmBidang,
		jabatanStat: null,
		bidangStat: null,
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
		},
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [dt, setDt] = useState(data ? data : frmPerangkat)

	const changeStatus = (e) => {
		setDt({
			...dt,
			status: e.value,
		})
	};

	const processGbr = (d) => {
		let type = d[0].type.split('/');
		if (
			type[1] === 'jpg' ||
			type[1] === 'jpeg' ||
			type[1] === 'png' ||
			type[1] === 'bmp' ||
			type[1] === 'tiff' ||
			type[1] === 'webp'
		) {
			
			let bodyFormData = new FormData();
			bodyFormData.append('files', d[0]);

			Post('upload-file/perangkat-lembaga', null, bodyFormData, (data) => {
			Resizer.imageFileResizer(
				d[0],
				300,
				300,
				type[1],
				100,
				0,
				(uri) => {
					setDt({
						...dt,
						foto: uri,
						foto_info: ''
					})
				},
				'base64'
			);
			});
		} else {
			setDt({
				...dt,
				foto: '',
				foto_info: <div className="text-danger font-size-10">Type file tidak valid</div>
			})
		}
    };

	
    const changeSelectValue = (e, sel) => {
		if (e) {
		  switch (sel) {
			case 'jabatan':
				setFormData({ 
					...formData,
					jabatanStat: e 
				});
			  break;
			case 'bidang':
				setFormData({ 
					...formData,
					bidangStat: e 
				});
			  break;
			default:
			  // no default
			  break;
		  }
		} else {
		  switch (sel) {
			case 'jabatan':
				setFormData({ jabatanStat: null });
			  break;
			case 'bidang':
				setFormData({ 
					...formData,
					bidangStat: null 
				});
			  break;
			default:
			  // no default
			  break;
		  }
		}
	};

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}

		setDt(data ? data : frmPerangkat)

		setFormData(data ? {
			...initFormData,
			jabatanStat: optionData.jabatanStat,
			bidangStat: optionData.bidangStat,
		} : initFormData)
	}, [isOpen])

	let uuid_jabatan = '';
	let uuid_bidang = '';
	if(formData.jabatanStat){
		uuid_jabatan = formData.jabatanStat.value
	}
	if(formData.bidangStat){
		uuid_bidang = formData.bidangStat.value
	}

	const simpan = (e) => {
		e.preventDefault();
		if(formData.jabatanStat && formData.bidangStat){
			let bodyRaw = {
				...dt,
				uuid : document.getElementById("uuid").value,
				uuid_lembaga : document.getElementById("uuid_lembaga").value,
				uuid_jabatan_lembaga : uuid_jabatan,
				uuid_bidang_lembaga : uuid_bidang,
				nama : document.getElementById("nama").value,
				status : document.getElementById("status").value,
				foto : dt.foto,
			}
	
			let psn = "";
			let resstat = 204;
			let metode = "create";
			if (bodyRaw.uuid === "") {
				psn = "Tambah";
				resstat = 201;
				bodyRaw.uuid = null;
			} else {
				psn = "Ubah";
				resstat = 200;
				metode = "update";
			}
				
			Post("perangkat-lembaga/" + metode, bodyRaw.uuid, bodyRaw,res => {
				setFormData({
					...formData,
					status: {
						...formData.status,
						btnForm: false,
						form: false,
					}
				})
				setIsOpen(false)
				if (res.status === resstat) {
					const alertData = {
						show: true,
						basicType: "success",
						basicTitle: "Data Perangkat Lembaga",
						pesanAlert: "Berhasil " + psn + " Data",
						successAlert: true,
					}
					setAlert(alertData)
				} else {
					const alertData = {
						show: true,
						basicType: "danger",
						basicTitle: "Data Perangkat Lembaga",
						pesanAlert: "Gagal " + psn + " Data"
					}
					setAlert(alertData)
				}
	
				// Refresh list
				setStatusRefresh(true)
			});
		}
		else{
			const alertData = {
				show: true,
				basicType: "warning",
				basicTitle: "Data Perangkat Lembaga",
				pesanAlert: "Data Tidak Lengkap!"
			}
			setAlert(alertData)
		}
	};

	return (
		<Modal
			classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={false}
			styles={{ modal: { width: '40%', maxWidth: 'unset' } }}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form"
				onSubmit={simpan} 
			>
				<div className="modal-header">
					<h5 className="modal-title">{dt.uuid == '' ? 'Tambah' : 'Edit'} Bidang Lembaga</h5>
				</div>
				<div className="modal-body">
					<input
						className="form-control"
						id="uuid"
						type="hidden"
						placeholder=""
						defaultValue={dt.uuid}
					/>
					<input
						className="form-control"
						id="uuid_lembaga"
						type="hidden"
						placeholder=""
						defaultValue={dt.uuid_lembaga}
					/>
					<FormGroup className="row">
						<Col sm='12'>
							<Label className="col-form-label" htmlFor="inputEmail3"><b>Nama Perangkat</b></Label>
							<input className="form-control" id="nama" type="text" placeholder="Nama Perangkat" defaultValue={dt.nama} required/>
						</Col>
						<Col sm='12'>
							<Label className="col-form-label" htmlFor="inputEmail3"><b>Jabatan Perangkat</b></Label>
							<Select
								classNamePrefix="select"
								onChange={(e) => {
									changeSelectValue(e, 'jabatan');
								}}
								defaultValue={formData.jabatanStat}
								value={formData.jabatanStat}
								name="jabatan"
								options={formData.frmJabatan}
								placeholder="Pilih Jabatan Perangkat"
								isClearable
							/>
						</Col>
						<Col sm='12'>
							<Label className="col-form-label" htmlFor="inputEmail3"><b>Bidang Perangkat</b></Label>
							<Select
								// isDisabled={this.state.statusPerangkat.select}
								classNamePrefix="select"
								onChange={(e) => {
									changeSelectValue(e, 'bidang');
								}}
								defaultValue={formData.bidangStat}
								value={formData.bidangStat}
								name="bidang"
								options={formData.frmBidang}
								placeholder="Pilih Bidang Perangkat"
								isClearable
							/>
						</Col>
						<Col sm='12'>
							<Label className="col-form-label" htmlFor="inputEmail3"><b>Foto Perangkat</b></Label>
							<Dropzone
								onDrop={(acceptedFiles) => processGbr(acceptedFiles)}
								maxFiles={1}
								>
								{({ getRootProps, getInputProps }) => (
									<section>
									<div
										{...getRootProps()}
										style={{
										minHeight: '100px',
										paddingTop: '40px',
										padding: '5px 5px 5px 5px',
										border: '1px solid #d2d2d2'
										}}
									>
										<input {...getInputProps()} />
										<p>
										{dt.foto ? (
											<img
											alt="Gambar Perangkat Kelembagaan"
											src={dt.foto}
											style={{
												minHeight: '50px',
												minWidth: '50px',
												maxWidth:'100%', border:'none',align:'center'
											}}
											/>
										) : (
											"Drag 'n' drop some files here, or click to select files"
										)}
										{dt.foto_info ? (
											dt.foto_info
										) : (
											''
										)}
										</p>
									</div>
									</section>
								)}
							</Dropzone>
						</Col>
						<Col sm='12'>
							<Label className="col-form-label" htmlFor="inputEmail3"><b>Status</b></Label>
							<select className="form-control" 
								id="status" 
								name='status' 
								defaultValue={dt.status} 
								value={dt.status} 
								onChange={e => {
									changeStatus(e);
								}}
							>
								<option value={1}>Aktif</option>
								<option value={0}>Tidak Aktif</option>
							</select>
						</Col>
					</FormGroup>
				</div>
				<div className="modal-footer">
					<button
						type="button"
						className="btn btn-warning"
						onClick={() => {
							setIsOpen(false)
						}}
					>
						Tutup
					</button>
					<button
						data-testid="btnSubmitCreate"
						type="submit"
						className="btn btn-primary-custom"
						disabled={formData.status && formData.status.btnForm}
					>
						Simpan
					</button>
				</div>
			</Form>
		</Modal>
	);
}

export default ModalPerangkat;
